<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">
          <div class="settings-header">
            Items (Type of Goods)
            <div class="settings-header__btn">
              <el-button type="success" size="mini" @click="routerLink('settings-dashboard')">Setting Dashboard</el-button>
            </div>
          </div>
          <div class="wrap__tree">
            <div class="nav-tree">
              <el-button @click="openModalAdd" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">{{$t('general_add')}} {{btnText}}</el-button>
            </div>
            <el-table
                max-height="650"
                :data="tableData"
                :empty-text="$t('general_noData')"
                style="width: 100%">
              <el-table-column
                  label="ID"
                  align="center"
                  type="index"
                  width="70">
              </el-table-column>
              <el-table-column
                  prop="code"
                  label="Code"
                  width="270">
              </el-table-column>
              <el-table-column
                  prop="typeOfGoods"
                  label="Type of Goods">
              </el-table-column>
              <el-table-column
                  prop="description"
                  align="center"
                  label="Description">
                  <template slot-scope="scope">
                    <el-popover
                      v-if="scope.row.description"
                      placement="top"
                      title="Description"
                      width="400"
                      trigger="click"
                      :content="scope.row.description">
                      <el-button size="mini" slot="reference" icon="el-icon-view"></el-button>
                    </el-popover>
                  </template>
              </el-table-column>
              <el-table-column
                  prop="examples"
                  label="Examples">
              </el-table-column>
              <el-table-column
                  prop="createdOn"
                  align="center"
                  label="Created On">
              </el-table-column>
              <el-table-column
                  width="120"
                  :label="$t('settings_accountThink_units_operations')">
                <template slot-scope="scope">
                  <el-button
                      size="mini"
                      type="primary"
                      plain
                      icon="el-icon-edit"
                      @click="handleEdit(scope.$index, scope.row)"></el-button>
                  <el-button
                      size="mini"
                      type="danger"
                      plain
                      icon="el-icon-delete"
                      @click="handleDelete(scope.$index, scope.row)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <!-- add -->
    <sweet-modal blocking :title="`${$t('general_add')} ${btnText}`" ref="openModal" class="modal" v-on:close="closeModal">
      <el-form :model="form" ref="form" status-icon :rules="rules" label-width="150px" label-position="top" class="demo-ruleForm">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="code">
              <el-input :label="$t('settings_accountThink_units_code')" v-model="form.code"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="typeOfGoods">
              <el-input label="Type of Goods" v-model="form.typeOfGoods"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24" :offset="0">
            <el-form-item label="Description" prop="description">
              <el-input type="textarea" label="Description" v-model="form.description"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24" :offset="0">
            <el-form-item label="Examples" prop="examples">
              <el-input type="textarea" label="Examples" v-model="form.examples"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('openModal')">{{$t('general_cancel')}}</el-button>
          <el-button @click="addItem('form')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>
    </sweet-modal>

    <!-- edit -->
    <sweet-modal blocking :title="`${$t('general_edit')} ${btnText}`" ref="openModalEdit" class="modal" v-on:close="closeModalEdit">
      <el-form :model="formEdit" ref="formEdit" status-icon :rules="rulesEdit" label-width="150px" label-position="top" class="demo-ruleForm">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="code">
              <el-input :label="$t('settings_accountThink_units_code')" v-model="formEdit.code"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="typeOfGoods">
              <el-input label="Type of Goods" v-model="formEdit.typeOfGoods"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24" :offset="0">
            <el-form-item label="Description" prop="description">
              <el-input type="textarea" label="Description" v-model="formEdit.description"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24" :offset="0">
            <el-form-item label="Examples" prop="examples">
              <el-input type="textarea" label="Examples" v-model="formEdit.examples"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('openModalEdit')">{{$t('general_cancel')}}</el-button>
          <el-button @click="editItem('formEdit')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>
    </sweet-modal>
  </div>
</template>

<script>
import axios from 'axios'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

export default {
  name: 'goods',
  components: {
    SweetModal
  },
  mounted() {
    this.loadList()
  },
  data() {
    return {
      btnText: 'Goods',
      tableData: [],
      selectedRowId: '',
      form:{
        code: '',
        typeOfGoods: '',
        description: '',
        examples: '',
      },
      formEdit:{
        code: '',
        typeOfGoods: '',
        description: '',
        examples: '',
      },
      rules: {
        code: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        typeOfGoods: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
      },
      rulesEdit: {
        code: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        typeOfGoods: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
      },
    }
  },
  methods: {
    openModalAdd(){
      this.$refs.openModal.open()
    },
    loadList(){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .get(`/api/v1/type-of-goods?companyId=${this.$route.query.companyId}&id=null`)
          .then(response => {
            this.tableData = response.data.data
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
    },
    handleEdit(index, row) {
      console.log(row)
      this.selectedRowId = row.id
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .get(`/api/v1/type-of-goods?companyId=null&id=${row.id}`)
          .then(response => {
            this.$refs.openModalEdit.open()
            this.formEdit.code = response.data.data.code
            this.formEdit.typeOfGoods = response.data.data.typeOfGoods
            this.formEdit.description = response.data.data.description
            this.formEdit.examples = response.data.data.examples
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
    },
    addItem(form){
      this.$refs[form].validate((valid) => {
        if (valid) {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .post(`/api/v1/type-of-goods`, {
                companyId: this.$route.query.companyId,
                code: this.form.code,
                typeOfGoods: this.form.typeOfGoods,
                description: this.form.description,
                examples: this.form.examples,
              })
              .then(response => {
                this.$refs.openModal.close()
                this.loadList()
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
        }else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    editItem(formEdit){
      this.$refs[formEdit].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .put(`/api/v1/type-of-goods?id=${this.selectedRowId}`, this.formEdit)
              .then(response => {
                this.$refs.openModalEdit.close()
                this.loadList()
                loader.hide()
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error);
              });
        }else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleDelete(index, row) {
      this.selectedRowId = row.id

      this.$confirm('This will permanently delete the Unit. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'info'
      }).then(() => {
        this.$message({
          type: 'success',
          message: 'Delete completed'
        });

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .delete(`/api/v1/type-of-goods?id=${this.selectedRowId}`)
            .then(response => {
              this.loadList()
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        });
      });
    },
    closeModal(){
      this.form.code = ''
      this.form.typeOfGoods = ''
      this.$refs['form'].resetFields();
    },
    closeModalEdit(){
      this.formEdit.code = ''
      this.formEdit.typeOfGoods = ''
      this.$refs['formEdit'].resetFields();
    },
    modalCancel(ref) {
      this.$refs[ref].close();
    },
    routerLink(page) {
      this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
    },
  }
}
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>